import React, { useEffect, useState } from 'react'; 
import { useNavigate, useParams } from 'react-router-dom';
import axios from 'axios';
import API_BASE_URL from '../../config';
import Swal from 'sweetalert2';
import './CreateCustomer.css';

const EditCustomer = () => {
  const [customerData, setCustomerData] = useState('');
  const [customerName, setCustomerName] = useState('');
  const [customerNumber, setCustomerNumber] = useState('');
  const [customerEmail, setCustomerEmail] = useState('');
  const [companyName, setCompanyName] = useState('');
  const [companyWebsite, setCompanyWebsite] = useState('');
  const [companyNumber, setCompanyNumber] = useState('');
  const [companyEmail, setCompanyEmail] = useState('');
  const [customerType, setCustomerType] = useState({ value: 'Company' });
  const { customerId } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    const fetchCustomers = async () => {
      const token = localStorage.getItem('token');
      const selectedOrg = localStorage.getItem('selectedOrg');

      if (!token) {
        navigate('/unauthorized');
        return;
      }
      const loadingAlert = Swal.fire({
        title: 'Loading ...',
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });

      try {
        const orgEnabledResponse = await axios.get(`${API_BASE_URL}/org/org-enabled`, {
          headers: {
            Authorization: `Bearer ${token}`,
            SelectedOrg: localStorage.getItem('selectedOrg'),
          },
        });

        const { isEnabled } = orgEnabledResponse.data;

        if (!isEnabled) {
          Swal.fire({
            title: 'Organization Disabled',
            text: 'This organization has been disabled by the admin. Please contact support for further assistance.',
            icon: 'error',
            confirmButtonText: 'OK',
          }).then(() => {
            navigate('/unauthorized');
          });
          return;
        }

        const customerResponse = await axios.get(`${API_BASE_URL}/customers/${customerId}`, {
          headers: {
            Authorization: `Bearer ${token}`,
            SelectedOrg: selectedOrg,
          },
        });

        if (customerResponse.status === 403) {
          navigate('/unauthorized');
        }
    
        const customer = customerResponse.data.customer;

        setCustomerName(customer.customer_name || '');
        setCustomerNumber(customer.customer_number || '');
        setCustomerEmail(customer.customer_email || '');

      } catch (error) {
        console.error('Error fetching admin status:', error);
        navigate('/unauthorized');
      } finally {
        loadingAlert.close();
      }
    };

    fetchCustomers();
  }, [navigate]);

  // Function to validate required fields based on customer type
  const validateFields = () => {
    return customerName && customerNumber && customerEmail;
  };

  const handleUpdateCustomer = async () => {
    if (!validateFields()) {
      Swal.fire({
        title: 'Error!',
        text: 'Please fill out all required fields.',
        icon: 'error',
        confirmButtonText: 'OK',
      });
      return;
    }
  
    try {
      const token = localStorage.getItem('token');
      const orgId = localStorage.getItem('selectedOrg');
  
      const payload = {
            customerId,
            customerName,
            customerNumber,
            customerEmail,
            customerType,
          };
  
      const response = await axios.post(`${API_BASE_URL}/customers/update`, payload, {
        headers: {
          Authorization: `Bearer ${token}`,
          SelectedOrg: orgId,
          'Content-Type': 'application/json',
        },
      });
  
      if (response.status === 201) {
        Swal.fire({
          title: 'Success!',
          text: 'Customer updated successfully!',
          icon: 'success',
          confirmButtonText: 'OK',
        }).then(() => {
          navigate('/organization/customer-management');
        });
      }
    } catch (error) {
      console.error('Error updating customer:', error);
      Swal.fire({
        title: 'Error!',
        text: 'Failed to update customer.',
        icon: 'error',
        confirmButtonText: 'OK',
      });
    }
  };

  return (
    <div className="organizations-container">
      <div className="organizations-header">
        <h1>Edit Customer</h1>
      </div>

      
        <div className="input-container">
            <div className="input-column">
              <label>Customer Name*</label>
              <input
                type="text"
                value={customerName}
                onChange={(e) => setCustomerName(e.target.value)}
                placeholder="Name"
                maxLength={255}
                required
              />

              <label>Customer Number*</label>
              <input
                type="number"
                value={customerNumber}
                onChange={(e) => setCustomerNumber(e.target.value)}
                placeholder="0400000000"
                maxLength={20}
                required
              />

              <label>Customer Email*</label>
              <input
                type="text"
                value={customerEmail}
                onChange={(e) => setCustomerEmail(e.target.value)}
                placeholder="Email"
                maxLength={255}
                required
              />
            </div>
      </div>

      <div className="button-container">
        <button
          className="create-org-button"
          onClick={handleUpdateCustomer}
        >
          Update Customer
        </button>
      </div>
    </div>
  );
};

export default EditCustomer;
